import { render, staticRenderFns } from "./ImgViewer.vue?vue&type=template&id=723aabdd&scoped=true"
import script from "./ImgViewer.vue?vue&type=script&lang=js"
export * from "./ImgViewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "723aabdd",
  null
  
)

export default component.exports